import { Box, Stack } from "@mui/material";
import React from "react";
import { useInView } from "react-intersection-observer";
import StatsColumn from "./StatsColumn";
import CommunicationCircle from "./CommunicationCircle";
import { motion } from "framer-motion";

import img1 from "./Images/Face To face.png";
import img2 from "./Images/Email&phone.png";
import img3 from "./Images/website.png";
import img4 from "./Images/App.png";
import img5 from "./Images/Business messaging.png";
import img6 from "./Images/Bot calling.png";
import img7 from "./Images/Vedio call.png";
import arrowImg from "./Images/arroww.png";

// grid images 
import gridImg1 from "./Images/01.png";
import gridImg2 from "./Images/02.png";
import gridImg3 from "./Images/03.png";
import gridImg4 from "./Images/04.png";
import gridImg5 from "./Images/05.png";
import gridImg6 from "./Images/06.png";

const images = [
  {
    id: "face-to-face",
    label: "Face-to-Face",
    image: img1,
    color: [233, 243, 247],
  },
  {
    id: "email-phone",
    label: "Email/Phone",
    image: img2,
    color: [237, 245, 237],
  },
  {
    id: "website",
    label: "Website",
    image: img3,
    color: [250, 235, 235],
  },
  {
    id: "app",
    label: "App",
    image: img4,
    color: [223, 231, 245],
  },
  {
    id: "business-messaging",
    label: "Business Messaging",
    image: img5,
    color: [245, 242, 242],
  },
  {
    id: "calling",
    label: "Calling",
    image: img6,
    color: [162, 202, 245],
  },
  {
    id: "video",
    label: "Video Calling",
    image: img7,
    color: [240, 240, 250],
  },
];

const gridImages = [gridImg1, gridImg2, gridImg3, gridImg4, gridImg5, gridImg6];
  

const Section1 = () => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.5,
  });

  // Define base sizes and increments for the circles
  const baseSize = 80; // Smallest circle size
  const sizeIncrement = 10; // Increment for each step

  // Function to calculate size based on item index
  const getSize = (index) => {
    if (index === 0) return baseSize; // Face-to-Face (smallest)
    if (index === 1) return baseSize + sizeIncrement; // Email/Phone
    if (index === 2) return baseSize + sizeIncrement * 2; // Website
    if (index === 3) return baseSize + sizeIncrement * 3; // App
    return baseSize + sizeIncrement * 4; // Business Messaging, Calling, and Video (same size)
  };

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        height: { xl: "100%", lg: "78%", md: "100%", sm: "100%" },
        marginBottom: { xl: "0px", lg: "20px", md: "20px" },
        // gap: 10,
        
      }}
    >
      <Stack
        sx={{
          //  border: "1px solid red",
          width: "100%",
          display: "flex",
          flexDirection: {
            xl: "row",
            lg: "row",
            md: "row",
            sm: "row",
            xs: "column",
          },
          height: { xl: "60%", lg: "60%", md: "100%", sm: "100%" },
          gap: 2,
          marginTop: -4,          
        }}
      >
        <Stack
          sx={{
            // border: "1px solid red",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            width: { xl: "78%", lg: "70%", md: "65%", sm: "55%" },
            height: "100%",
            
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", // 3 columns
              gridTemplateRows: "repeat(2, 1fr)", // 2 rows
              gap: 2, 
            }}
          >
            {gridImages.map((url, index) => (
              <Box
                key={index}
                sx={{
                  // border: "1px solid red",
                  width: "100%",
                  height: "100%",
                  borderRadius: "8px",
                  overflow: "hidden",
                  // boxShadow: "0 0 2px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img
                  src={url}
                  alt={`Grid ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Stack>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            width: { xl: "22%", lg: "30%", md: "35%", sm: "45%" },
          }}
        >
          <StatsColumn />
        </Stack>
      </Stack>

      <Stack
        sx={{
          width: { xl: "100%", lg: "100%", md: "100%", sm: "100%" },
          height: "100%",
          // border: "1px solid red",
          // border: "1px solid #ddd",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "2rem",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        {images.map((item, index) => (
          <React.Fragment key={item.id}>
            {/* Communication Circle */}
            <Box
              sx={{
                position: "relative",
                zIndex: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CommunicationCircle item={item} size={getSize(index)} />
            </Box>

            {/* Arrow Image (Only between items) */}
            {index !== images.length - 1 && (
              <Box
                sx={{
                  mx: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={arrowImg}
                  alt="arrow"
                  style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain",
                    filter: "brightness(0) saturate(100%) invert(75%)",
                  }}
                />
              </Box>
            )}
          </React.Fragment>
        ))}
      </Stack>
    </Stack>
  );
};

export default Section1;
